import reducer from './reducer'
import {
  error,
  success,
  reset,
} from './actions'

export default {
  reducer,
  error,
  success,
  reset,
}



// WEBPACK FOOTER //
// ./src/store/Notification/index.js